module.exports = __webpack_public_path__ + "static/media/jayco2.eea77dcf.JPG";